import React from "react";
import "./PrintData.css";
import Logo from "../../Images/Logo.png";
import whiteLogo from "../../Images/tom_white.svg";
import dateFormat from "dateformat";
import { formatMoney } from "../../App";
export default class PrintData extends React.Component {
    renderTableChunk = (dataChunk, startIndex, totalChunks, rowsPerPage) => {
        const { printTableData, HeadingButton, type, } = this.props;
        const representativePrintData = HeadingButton && HeadingButton.length > 0 ? HeadingButton[0] : null;
        const totalPages = Math.round(totalChunks / rowsPerPage); // Use Math.round to round off the total pages
        const currentPage = Math.round(startIndex / rowsPerPage) + 1; // Use Math.round to round off the current page

        return (
            <div className="printtabledata" key={startIndex}>
                <img className="platform_logo_print" src={Logo} alt="image error" />
                {type === 'settlement' && (<div className="printDataTitle">Settlement Details </div>)}
                {type === 'revenue' && (<div className="printDataTitle">Revenue Details </div>)}
                <div className='kwd_vlaues_font'>All values in INR</div>
                <table>
                    {type === 'settlement' && (
                        <thead>
                            <tr className="print_header">
                                <th className="print_header_text23" style={{ textAlign: 'center' }}>S.No</th>
                                <th className="print_header_text23" style={{ textAlign: 'center' }}>Settlement Month</th>
                                <th className="print_header_text23" style={{ textAlign: 'center' }}>Transaction</th>
                                <th className="print_header_text23" style={{ textAlign: 'center' }}>Settlement ID</th>
                                <th className="print_header_text23" style={{ textAlign: 'center' }}>Receivable</th>
                            </tr>
                            <tr>
                                <th className="print_header_textss"></th>
                                <th className="print_header_textss"></th>
                                <th className="print_header_textss"></th>
                                <th className="print_head_Text_color1" style={{ textAlign: 'center' }}>Total</th>
                                <th className="print_head_Text_color1" style={{ textAlign: 'right' }}>{representativePrintData ? representativePrintData.revenueTotal : ''}</th>
                            </tr>
                        </thead>
                    )}

                    {type === 'revenue' && (
                        <thead>
                            <tr className="print_header">
                                <th className="print_header_text" style={{ textAlign: 'center' }}>S.No</th>
                                <th className="print_header_text" style={{ textAlign: 'center' }}>Date</th>
                                <th className="print_header_text" style={{ textAlign: 'center' }}>Member</th>
                                <th className="print_header_text" style={{ textAlign: 'center' }}>Medicine Unit</th>
                                <th className="print_header_text" style={{ textAlign: 'center' }}>Fee</th>
                                <th className="print_header_text" style={{ textAlign: 'center' }}>Platform Fee</th>
                                <th className="print_header_text" style={{ textAlign: 'center' }}>Income</th>
                            </tr>
                            <tr>
                                <th className="print_header_textss"></th>
                                <th className="print_header_textss"></th>
                                <th className="print_header_textss"></th>
                                <th className="print_head_Text_color1" style={{ textAlign: 'center' }}>Total</th>
                                <th className="print_head_Text_color1" style={{ textAlign: 'right' }}>{representativePrintData ? representativePrintData.revenueFee : ''}</th>
                                <th className="print_head_Text_color1" style={{ textAlign: 'right' }}>{representativePrintData ? representativePrintData.revenueTomshare : ''}</th>
                                <th className="print_head_Text_color1" style={{ textAlign: 'right' }}>{representativePrintData ? representativePrintData.revenueTotal : ''}</th>
                            </tr>
                        </thead>
                    )}




                    <tbody>
                        {dataChunk.map((printdata, index) => (
                            <tr key={index}>
                                {type === 'revenue' && (
                                    <>
                                        <td className="print_header_textss" style={{ textAlign: 'center' }}>{index + startIndex + 1}</td>
                                        <td className="print_header_textss" style={{ textAlign: 'center' }}>{dateFormat(printdata.payment_date, 'dd-mmm-yy')}</td>
                                        <td className="print_header_textss">{printdata.name}</td>
                                        <td className="print_header_textss" style={{ textAlign: 'center' }}>{printdata.unit}</td>
                                        <td className="print_header_textss" style={{ textAlign: 'right' }}>{formatMoney(printdata.fee)}</td>
                                        <td className="print_header_textss" style={{ textAlign: 'right' }}>{formatMoney(printdata.tomShare)}</td>
                                        <td className="print_header_textss" style={{ textAlign: 'right' }}>{formatMoney(printdata.inCome)}</td>
                                    </>
                                )}
                                {type === 'settlement' && (
                                    <>
                                        <td className="print_header_textss" style={{ textAlign: 'center' }}>{index + startIndex + 1}</td>
                                        <td className="print_header_textss" style={{ textAlign: 'center' }}>{dateFormat(printdata.settlement_date, 'mmm-yy')}</td>
                                        <td className="print_header_textss" style={{ textAlign: 'center' }}>{printdata.transaction_count}</td>
                                        <td className="print_header_textss" style={{ textAlign: 'center' }}>{printdata.settlement_no}</td>
                                        <td className="print_header_textss" style={{ textAlign: 'right' }}>{printdata.settlement_amount}</td>
                                    </>
                                )}
                                {/* Add other conditions for different types similarly */}
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div className="print_footer">
                    Page {currentPage} of {totalPages}
                </div>
                {dataChunk.length === rowsPerPage && <div className="page-break"></div>}
            </div>
        );
    };

    render() {
        const rowsPerPage = 30;
        const { printTableData } = this.props;
        const totalChunks = Math.ceil(printTableData.length / rowsPerPage);

        const tableChunks = [];
        for (let i = 0; i < totalChunks; i++) {
            const startIndex = i * rowsPerPage;
            const dataChunk = printTableData.slice(startIndex, startIndex + rowsPerPage);
            if (dataChunk.length > 0) {
                tableChunks.push(this.renderTableChunk(dataChunk, startIndex, printTableData.length, rowsPerPage));
            }
        }
        return <div>{tableChunks}</div>;
    }

}
